export default __webpack_public_path__ + "static/media/alphabet.cc537b36.svg";